import { PersonCircle } from "react-bootstrap-icons";

const sizeClasses = {
  xs: "avatar-xs",
  sm: "avatar-sm",
  md: "avatar-md",
  lg: "avatar-lg",
  xl: "avatar-xl",
};

const Avatar = ({ src, alt = "", size = "md", className = "" }) => {
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  if (!src) {
    return (
      <div className={`avatar ${sizeClass} ${className}`}>
        <PersonCircle className="w-100 h-100" style={{ color: "var(--text-tertiary)" }} />
      </div>
    );
  }

  return (
    <div className={`avatar ${sizeClass} ${className}`}>
      <img src={src} alt={alt} className="avatar-image" />
    </div>
  );
};

export default Avatar;
